import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTeams } from "./teamsSlice";
import styles from "./Teams.module.css";
import { TransparentSelect } from '../inputs/TransparentSelect';

export function TeamSelector(props) {

    const dispatch = useDispatch()

    const teams = useSelector((state) => state.teams.list)
    const myTeam = useSelector((state) => state.teams.myTeam)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    const handleSelectedTeamsChange = (teamsIds) => {
        dispatch(setSelectedTeams(teamsIds))
    }

    let teamsOptions = []

    // With nothing to choose between, the selector is read-only text — still
    // badged so it reads as the same "current team" control as the dropdown.
    function renderStaticTeam(label) {
        return <span className={styles.teamLabel} title={label}>
            <i className="pi pi-users" aria-hidden="true" />
            <span className={styles.teamLabelText}>{label}</span>
        </span>
    }

    if (props.onlyMyTeams) {
        return renderStaticTeam(myTeam.label)
    }

    if (myTeam && props.includeMyTeam) {
        teamsOptions = [myTeam]
    }

    if (teams)
        teamsOptions = teamsOptions.concat(teams.filter(team => !teamsOptions.filter(t=> t.id == team.id).length))

    if (teamsOptions && teamsOptions.length == 1) {
        return renderStaticTeam(teamsOptions[0].label)
    }

    return <TransparentSelect
        icon="pi-users"
        options={teamsOptions}
        value={selectedTeamsIds}
        min={1}
        max={15}
        onChange={handleSelectedTeamsChange} />
}
